module.exports = __webpack_public_path__ + "img/giphy2.d71d8ccb.gif";